import {Component, Vue, Watch} from "vue-property-decorator";
import {Subscription} from "webstomp-client";
import {AXIOS} from "@/lib/http-common";
import ErrorLog from "@/components/error-log/model/ErrorLog";
import {debounce} from '@/lib/util';
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS, STOMP_TOPICS} from "@/lib/constants";

@Component({})
export default class ErrorLogs extends Vue {

  public searchErrorLog: string = "";
  public errorLogEntrySub!: Subscription;
  public dataTableOptions: any = {
    itemsPerPage: 30,
    sortBy: ['startDate'],
    sortDesc: [true]
  };
  public total: number = 0;
  public loading: boolean = true;
  public errorLogList: ErrorLog[] = [];

  public showErrorDialog: boolean = false;
  public selectedErrorLog: ErrorLog = null!;

  public recordingMaximized: boolean = false;
  public isDeletingErrors: boolean = false;

  get errorLogHeaders() {
    return [
      {text: this.$t('errorLog.tableHeaders.componentType'), value: "definition.componentType"},
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "definition.errorId"
      },
      {text: this.$t('errorLog.tableHeaders.level'), sortable: false, value: "definition.errorLevel"},
      {text: this.$t('errorLog.tableHeaders.title'), sortable: false, value: "title"},
      {text: this.$t('errorLog.tableHeaders.start'), value: "startDate"},
      {text: this.$t('errorLog.tableHeaders.end'), value: "endDate"},
    ];
  }

  public created() {
    this.getFilteredErrorLog = debounce(this.getFilteredErrorLog, 300);
  }

  public mounted() {
    EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);
    this.websocketConnected(this.$store.state.stompClient.connected);
    EventBus.$on(EVENTBUS_TOPICS.LANGUAGE_CHANGE, () => {
      this.getFilteredErrorLog();
    });
  }

  public websocketConnected(state: boolean) {
    if (state) {
      this.errorLogEntrySub = this.$store.state.stompClient.subscribe(
        STOMP_TOPICS.ERROR_LOG_UPDATE,
        () => {
          this.getFilteredErrorLog();
        }
      );
    }
  }

  public showErrorLogDialog(errorLog: ErrorLog) {
    this.selectedErrorLog = errorLog;
    this.showErrorDialog = true;
  }

  @Watch('showErrorDialog')
  public onShowErrorDialogChange() {
    if (!this.showErrorDialog) {
      this.selectedErrorLog = null!;
    }
  }

  public getFilteredErrorLog() {
    this.loading = true;
    AXIOS.post("/error-log/", this.dataTableOptions, {
      params: {
        searchQuery: this.searchErrorLog,
        language: this.$i18n.locale.toUpperCase()
      }
    }).then((message) => {
      this.errorLogList = [];

      for (const err of message.data.content) {
        this.errorLogList.push(new ErrorLog(err));
      }
      this.total = message.data.totalElements;
    }).finally(() => {
      this.loading = false;
    });
  }

  public onRecordingMaximized(maximized: boolean) {
    this.recordingMaximized = maximized;
  }

  @Watch('dataTableOptions')
  public onDataTableOptionsChange() {
    this.getFilteredErrorLog();
  }

  @Watch("searchErrorLog")
  public searchQueryWatcher() {
    this.dataTableOptions.page = 1;
    this.getFilteredErrorLog();
  }

  public beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);

    if (this.errorLogEntrySub !== null) {
      this.errorLogEntrySub.unsubscribe();
    }

    EventBus.$off(EVENTBUS_TOPICS.LANGUAGE_CHANGE);
  }

  public deleteErrors() {
    this.loading = true;
    this.isDeletingErrors = true;
    AXIOS.delete("/error-log/delete-errors")
      .then(() => {
        this.errorLogList = [];
        this.total = 0;
      })
      .finally(() => {
        this.loading = false;
        this.isDeletingErrors = false;
      });
  }
}
